import firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/storage';
import * as firebaseui from 'firebaseui';

const firebaseConfig = {
  apiKey: 'AIzaSyD0oLz2hssB0ktbg8UNiax2XtMPEkImJOo',
  authDomain: 'lifespan-kr.firebaseapp.com',
  projectId: 'lifespan-kr',
  storageBucket: 'lifespan-kr.appspot.com',
  messagingSenderId: '1025776241360',
  appId: '1:1025776241360:web:010d2b449ffc63def5ecd5',
};

firebase.initializeApp(firebaseConfig);

export const firebaseInstance = firebase;

export const dbService = firebase.firestore();

export const storageService = firebase.storage();

export const ui = new firebaseui.auth.AuthUI(firebase.auth());
